import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const moaService = {
  getAllMoas,
  updateMoaStatus,
  getMoa,
  updateMoa,
  createMoa,
};

const MODULE = {
  MOA: 'rnd-product-moas',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'label') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllMoas(filter) {

  const requestOptions = {
    params: {
      page: filter.pageNumber,
      size: filter.pageSize,
      product: filter.product,
      moa: filter.moa,
      is_active: filter.isActive
    }
  }

  let array = filter.searchArray
  array.forEach((word, index) => {
    if (word != null || word != '') {
      var searchParam = `search_words[${index}]`
      requestOptions.params[searchParam] = word
    }
  })

  return await apiHelper(API_URL).get(`/${MODULE.MOA}`, requestOptions)
}


export function updateMoaStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.MOA}/${data.id}`, requestOptions)
}

export function getMoa(id) {
  return apiHelper(API_URL).get(`/${MODULE.MOA}/${id}`)
}

export function updateMoa(data) {
 const requestOptions = {
    product_uuid: data.productID,
    moa_uuid: data.moaID,
  }

  return apiHelper(API_URL).put(`/${MODULE.MOA}/${data.id}`, requestOptions)
}

export function createMoa(data) {
  const requestOptions = {
    product_uuid: data.productID,
    moa_uuid: data.moaID,
  }

  return apiHelper(API_URL).post(`/${MODULE.MOA}`, requestOptions)
}